module.exports = {
    tag: 'rejuvenation',
    quality: 0.8,
    toughness: 2,
    willpower: 3,
    regeneration: 2.0
};